module.exports = "/dog-racing/img/first-dog.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/first-dog.png
// module id = 1955
// module chunks = 7